module.exports = __webpack_public_path__ + "img/company.aa7bd2b6.svg";